<template>
  <v-dialog
    :value="value"
    persistent
    max-width="900px"
    scrollable
    data-cy="bulk-ua-failures-dialog"
  >
    <v-card>
      <v-card-title class="text-h5">Bulk Classify Errors</v-card-title>
      <v-card-text data-cy="bulk-ua-failures">
        <v-alert type="error" outlined dense class="mb-0">
          <div
            v-for="(failure, index) in localFailures"
            :key="failure.discovery.id"
            :class="{ 'mt-4': index > 0 }"
            class="bulk-failure"
          >
            <div class="text-break">
              <strong>user_agent:</strong> {{ failure.discovery.user_agent }}
            </div>
            <div v-for="(messages, field) in failure.errors" :key="field">
              <strong>error:</strong> "{{ field }}": {{ formatErrorMessages(messages) }}
            </div>
            <v-btn
              v-if="isPatternAlreadyTaken(failure)"
              color="error"
              small
              outlined
              class="mt-2"
              data-cy="remove-discovery"
              :loading="removingId === failure.discovery.id"
              @click="removeDiscovery(failure, index)"
            >
              Remove
            </v-btn>
          </div>
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" data-cy="close-failures-dialog" @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import HTTP from '@/api/ant';

export const isPatternAlreadyTaken = failure => {
  const patternErrors = failure.errors?.pattern;
  if (patternErrors == null) return false;
  const messages = Array.isArray(patternErrors) ? patternErrors : [patternErrors];
  return messages.some(msg =>
    String(msg)
      .toLowerCase()
      .includes('already been taken'),
  );
};

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    failures: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    removingId: null,
    localFailures: [],
  }),
  watch: {
    value: {
      immediate: true,
      handler(open) {
        if (open) {
          this.localFailures = this.failures.map(failure => ({ ...failure }));
        }
      },
    },
  },
  methods: {
    formatErrorMessages(messages) {
      return Array.isArray(messages) ? messages.join(', ') : messages;
    },
    isPatternAlreadyTaken,
    close() {
      this.$emit('input', false);
    },
    removeDiscovery(failure, index) {
      const { id } = failure.discovery;
      this.removingId = id;
      return HTTP.post(`/ios/ua/discoveries/${id}/remove`, {}, { niSkipFlash: true })
        .then(() => {
          this.$flash('success', 'Discovery successfully removed');
          this.localFailures.splice(index, 1);
          this.$emit('saved');
          if (!this.localFailures.length) {
            this.close();
          }
        })
        .catch(err => {
          const message =
            err.response?.data?.error ||
            err.response?.data?.errors?.base?.[0] ||
            'Failed to remove discovery';
          this.$flash('error', message);
        })
        .finally(() => {
          this.removingId = null;
        });
    },
  },
};
</script>

<style scoped>
.bulk-failure + .bulk-failure {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding-top: 16px;
}
</style>
